import { BrandColor } from 'src/types'

import BrandColorButton from './BrandColorButton/BrandColorButton'
import WhiteButton from './WhiteButton/WhiteButton'

export type WhatAnItListButtonVariant = 'white' | 'brandColor'

const WhatsAnItListButton: React.FC<{
  brandColor: BrandColor
  variant: WhatAnItListButtonVariant
  onClick: React.MouseEventHandler
}> = ({ brandColor, onClick, variant }) => {
  return variant === 'brandColor' ? (
    <BrandColorButton brandColor={brandColor} onClick={onClick} />
  ) : (
    <WhiteButton brandColor={brandColor} onClick={onClick} />
  )
}

export default WhatsAnItListButton
